import { z } from "zod";

const EMAIL_ALREADY_USED = "email_already_used";

const duplicateEmailErrorSchema = z.object({
  response: z.object({
    data: z.object({
      error: z.object({
        code: z.literal(EMAIL_ALREADY_USED),
        user: z.object({
          id: z.string(),
          firstName: z.string(),
          lastName: z.string(),
        }),
      }),
    }),
  }),
});

export type ExistingUser = z.infer<
  typeof duplicateEmailErrorSchema
>["response"]["data"]["error"]["user"];

export const parseExistingUser = (error: unknown): ExistingUser | null => {
  const parsed = duplicateEmailErrorSchema.safeParse(error);

  return parsed.success ? parsed.data.response.data.error.user : null;
};
